import React from 'react';
// eslint-disable-next-line import/no-unresolved
import '../cssOverrides/SwitchButton.scss';

function SwitchButton({ disabled, checked, onChange }) {
  const handleToggle = () => {
    const newState = !checked;
    onChange(newState);
  };

  return (
    <div className="custom-switch-wrapper">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        className={`custom-switch-button ${checked ? 'checked' : ''}`}
        onClick={handleToggle}
      >
        <div className={`knob ${checked ? 'checked' : ''}`} />
      </button>
    </div>
  );
}

export default SwitchButton;
